import { FieldType } from '../../types/enums'
import { ItemAttribute } from '../../types/interfaces'

export const useSaleItemAttributes = () => {
  const sortRequiredFirst = (a: ItemAttribute, b: ItemAttribute): number => {
    if (a.isRequired && !b.isRequired) return -1
    if (!a.isRequired && b.isRequired) return 1
    return 0
  }

  const formatAttributeValue = (attribute: ItemAttribute): string => {
    const { fieldType, value, unit } = attribute

    if (fieldType === FieldType.CHECKBOX) {
      return value === true || value === 'true' ? 'Да' : 'Нет'
    }

    if (fieldType === FieldType.MULTISELECT && typeof value === 'string') {
      return value.replace(/[\[\]"]/g, '').trim()
    }

    const valueStr = String(value)
    // ИСПРАВЛЕНИЕ: проверяем unit !== undefined, т.к. 0 !== undefined true
    const unitStr = unit !== undefined && unit !== -1 ? ` ${getUnitShort(unit)}` : ''

    return `${valueStr}${unitStr}`
  }

  const getUnitShort = (unit: number): string => {
    const map: Record<number, string> = {
      0: 'г',
      1: 'кг',
      2: 'т',
      3: 'мл',
      4: 'л',
      5: 'шт',
      6: 'см',
      7: 'м',
      8: 'мин',
      9: 'ч',
      10: 'дн',
      11: 'мес',
      12: 'год',
    }
    return map[unit] || ''
  }

  return { sortRequiredFirst, formatAttributeValue }
}
